import * as Types from '../../../__generated__/types.generated';

import { gql } from '@apollo/client';
import { ContactFragmentOnContactFeedFragmentDoc } from '../../../crm/contacts/__generated__/contact-fragment.generated';
import { StepImageUploadOnFeedFragmentDoc } from '../../../media/step-image-uploads/__generated__/step-image-upload.fragment.generated';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type UpdateContentMutationVariables = Types.Exact<{
  input: Types.UpdateContentInput;
}>;


export type UpdateContentMutation = { __typename?: 'RootMutationType', updateContent?: { __typename?: 'ContentResult', content?: { __typename?: 'Content', id: string, type: Types.ContentType, groupType: Types.ContentGroupType, label?: string | null, plainDescription?: string | null, body?: any | null, embedLink?: string | null, oembedResult?: any | null, providerName?: string | null, videoContain?: boolean | null, video?: { __typename?: 'VideoUpload', id: string, rawUrl?: string | null, transcodedUrl?: string | null, previewUrl?: string | null, streamUrl?: string | null, gifUrl?: string | null, gifWithIconUrl?: string | null, contact?: { __typename?: 'Contact', id: string, email?: string | null, firstName?: string | null, lastName?: string | null, title?: string | null, avatarThumbUrl?: string | null, insertedAt?: any | null, company?: { __typename?: 'Company', id: string, name: string, iconUrl?: string | null, thumbUrl?: string | null } | null } | null } | null, image?: { __typename?: 'StepImageUpload', id: string, name?: string | null, originalUrl?: string | null, fhdUrl?: string | null, alternativeText?: string | null, insertedAt?: any | null, size?: number | null, width?: number | null, height?: number | null, originalWidth?: number | null, originalHeight?: number | null } | null, narration?: { __typename?: 'ContentNarration', id: string, title?: string | null, type?: Types.NarrationType | null, video?: { __typename?: 'VideoUpload', id: string, rawUrl?: string | null, transcodedUrl?: string | null, previewUrl?: string | null, streamUrl?: string | null, gifUrl?: string | null, gifWithIconUrl?: string | null } | null, chapters?: Array<{ __typename?: 'NarrationChapter', id: string, title?: string | null, slidePageNumber?: number | null, video?: { __typename?: 'VideoUpload', id: string, rawUrl?: string | null, transcodedUrl?: string | null, previewUrl?: string | null, streamUrl?: string | null, gifUrl?: string | null, gifWithIconUrl?: string | null } | null }> | null } | null, file?: { __typename?: 'FileUpload', id: string, name?: string | null, size?: number | null, pageCount?: number | null, mimeType?: string | null, fileUrl?: string | null } | null, formFields?: Array<{ __typename?: 'AudioField' } | { __typename?: 'EmailField', id: string, key?: string | null, label: string, isRequired: boolean, isHidden: boolean } | { __typename?: 'LongTextField', id: string, key?: string | null, label: string, isRequired: boolean, isHidden: boolean } | { __typename?: 'PhoneField', id: string, key?: string | null, label: string, isRequired: boolean, isHidden: boolean } | { __typename?: 'ShortTextField', id: string, key?: string | null, label: string, isRequired: boolean, isHidden: boolean } | { __typename?: 'VideoField' } | null> | null } | null, userErrors?: Array<{ __typename?: 'UserError', field: string, message: string } | null> | null } | null };


export const UpdateContentDocument = gql`
    mutation updateContent($input: UpdateContentInput!) {
  updateContent(input: $input) {
    content {
      id
      type
      groupType
      label
      plainDescription
      body
      embedLink
      oembedResult
      providerName
      videoContain
      video {
        id
        rawUrl
        transcodedUrl
        previewUrl
        streamUrl
        gifUrl
        gifWithIconUrl
        contact {
          ...ContactFragmentOnContactFeed
        }
      }
      image {
        ...StepImageUploadOnFeed
      }
      narration {
        id
        title
        type
        video {
          id
          rawUrl
          transcodedUrl
          previewUrl
          streamUrl
          gifUrl
          gifWithIconUrl
        }
        chapters {
          id
          title
          slidePageNumber
          video {
            id
            rawUrl
            transcodedUrl
            previewUrl
            streamUrl
            gifUrl
            gifWithIconUrl
          }
        }
      }
      file {
        id
        name
        size
        pageCount
        mimeType
        fileUrl
      }
      image {
        id
        name
        originalUrl
        fhdUrl
        alternativeText
        insertedAt
      }
      formFields {
        ... on EmailField {
          id
          key
          label
          isRequired
          isHidden
        }
        ... on ShortTextField {
          id
          key
          label
          isRequired
          isHidden
        }
        ... on LongTextField {
          id
          key
          label
          isRequired
          isHidden
        }
        ... on PhoneField {
          id
          key
          label
          isRequired
          isHidden
        }
      }
    }
    userErrors {
      field
      message
    }
  }
}
    ${ContactFragmentOnContactFeedFragmentDoc}
${StepImageUploadOnFeedFragmentDoc}`;
export type UpdateContentMutationFn = Apollo.MutationFunction<UpdateContentMutation, UpdateContentMutationVariables>;

/**
 * __useUpdateContentMutation__
 *
 * To run a mutation, you first call `useUpdateContentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateContentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateContentMutation, { data, loading, error }] = useUpdateContentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateContentMutation(baseOptions?: Apollo.MutationHookOptions<UpdateContentMutation, UpdateContentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateContentMutation, UpdateContentMutationVariables>(UpdateContentDocument, options);
      }
export type UpdateContentMutationHookResult = ReturnType<typeof useUpdateContentMutation>;
export type UpdateContentMutationResult = Apollo.MutationResult<UpdateContentMutation>;
export type UpdateContentMutationOptions = Apollo.BaseMutationOptions<UpdateContentMutation, UpdateContentMutationVariables>;